import { createFileRoute, redirect } from '@tanstack/react-router'
import { CompleteProfilePage } from './complete-profile.page'

export const Route = createFileRoute('/complete-profile')({
  beforeLoad: async () => {
    try {
      const res = await fetch('/api/users/me', { credentials: 'include' })
      if (!res.ok) throw new Error('not authenticated')
      const user = await res.json()
      if (!user) throw new Error('not authenticated')
      // Jika sudah punya nomor WA dan jabatan, redirect ke dashboard
      if (user.nomor_wa && user.jabatan) {
        const staffRoles = ['kepala_desa', 'sekretaris_desa', 'operator_desa']
        if (user.role === 'platform_admin' || user.is_qc) {
          throw redirect({ to: '/platform' })
        }
        if (staffRoles.includes(user.role) && user.status === 'approved' && user.desa?.slug) {
          throw redirect({ to: `/desa/${user.desa.slug}/dashboard` as any })
        }
      }
      return { user }
    } catch (e) {
      if ((e as any)?.to) throw e
      throw redirect({ to: '/login' })
    }
  },
  component: function CompleteProfileRoute() {
    const { user } = Route.useRouteContext() as any
    return <CompleteProfilePage user={user} />
  },
})
